export const adminRoutes = [
  {
    path: '/manage',
    redirect: '/manage/news',
  },
  {
    name: 'admin-login',
    path: 'login',
    component: () => import('~/admin/pages/login'),
  },
  {
    path: 'users',
    component: () => import('~/admin/pages/users'),
    name: 'admin-users',
  },
  {
    path: 'users/:id',
    component: () => import('~/admin/pages/users-edit'),
    name: 'admin-users-edit',
  },
  {
    path: 'news',
    component: () => import('~/admin/pages/news'),
    name: 'admin-news',
  },
  {
    path: 'news/:id',
    component: () => import('~/admin/pages/news-edit'),
    name: 'admin-news-edit',
  },
  {
    path: 'news/:id/history',
    component: () => import('~/admin/pages/news-history'),
    name: 'admin-news-history',
  },
  {
    path: 'news/:id/history/:historyId',
    component: () => import('~/admin/pages/news-history-item'),
    name: 'admin-news-history-item',
  },
  {
    path: 'mailing',
    component: () => import('~/admin/pages/mailing'),
    name: 'admin-mailing',
  },
  {
    path: 'mailing/:id',
    component: () => import('~/admin/pages/mailing-edit'),
    name: 'admin-mailing-edit',
  },
  {
    path: 'chronicle',
    component: () => import('~/admin/pages/chronicle'),
    name: 'admin-chronicle',
  },
  {
    path: 'news-feed',
    component: () => import('~/admin/pages/feed'),
    name: 'admin-news-feed',
  },
  {
    path: 'companies-feed',
    component: () => import('~/admin/pages/feed'),
    name: 'admin-companies-feed',
  },
  {
    path: 'feed-special',
    component: () => import('~/admin/pages/feed-special'),
    name: 'admin-feed-special',
  },
  {
    path: 'main-news',
    component: () => import('~/admin/pages/main-news'),
    name: 'admin-main-news',
  },
  {
    path: 'gismeteo-rss',
    component: () => import('~/admin/pages/gismeteo-rss'),
    name: 'admin-gismeteo-rss',
  },
  {
    path: 'video',
    component: () => import('~/admin/pages/video'),
    name: 'admin-video',
  },
  {
    path: 'offices',
    component: () => import('~/admin/pages/offices'),
    name: 'admin-offices',
  },
  {
    path: 'events',
    component: () => import('~/admin/pages/events'),
    name: 'admin-events',
  },
  {
    path: 'events/:id',
    component: () => import('~/admin/pages/events-edit'),
    name: 'admin-events-edit',
  },
  {
    path: 'partner-types',
    component: () => import('~/admin/pages/partner-types'),
    name: 'admin-partner-types',
  },
  {
    path: 'employee-roles',
    component: () => import('~/admin/pages/employee-roles'),
    name: 'admin-employee-roles',
  },
  {
    path: 'speakers',
    component: () => import('~/admin/pages/speakers'),
    name: 'admin-speakers',
  },
  {
    path: 'employees',
    component: () => import('~/admin/pages/employees'),
    name: 'admin-employees',
  },
  {
    path: 'partners',
    component: () => import('~/admin/pages/partners'),
    name: 'admin-partners',
  },
  {
    path: 'afisha-events',
    component: () => import('~/admin/pages/afisha-events'),
    name: 'admin-afisha-events',
  },
  {
    path: 'events-main',
    component: () => import('~/admin/pages/events-main'),
    name: 'admin-events-main',
  },
  {
    path: 'events-affiche',
    component: () => import('~/admin/pages/events-affiche'),
    name: 'admin-events-affiche',
  },
  {
    path: 'events-partners',
    component: () => import('~/admin/pages/events-partners'),
    name: 'admin-events-partners',
  },
  {
    path: 'retail',
    component: () => import('~/admin/pages/afisha-events'),
    name: 'admin-retail',
  },
  {
    path: 'stories',
    component: () => import('~/admin/pages/stories'),
    name: 'admin-stories',
  },
  {
    path: 'plus',
    component: () => import('~/admin/pages/plus'),
    name: 'admin-plus',
  },
  {
    path: 'special',
    component: () => import('~/admin/pages/special'),
    name: 'admin-special',
  },
  {
    path: 'day-number',
    component: () => import('~/admin/pages/day-number'),
    name: 'admin-day-number',
  },
  {
    path: 'experts',
    component: () => import('~/admin/pages/experts'),
    name: 'admin-experts',
  },
  {
    path: 'photos-galleries',
    component: () => import('~/admin/pages/photos-galleries'),
    name: 'admin-photos-galleries',
  },
  {
    path: 'photos',
    component: () => import('~/admin/pages/photos'),
    name: 'admin-photos',
  },
  {
    path: 'photos/:id',
    component: () => import('~/admin/pages/photos-edit'),
    name: 'admin-photo-edit',
  },
  {
    path: 'photo-gallery',
    component: () => import('~/admin/pages/photo-gallery'),
    name: 'admin-photo-gallery',
  },
  {
    path: 'photo-gallery/:id',
    component: () => import('~/admin/pages/photo-gallery-edit'),
    name: 'admin-photo-gallery-edit',
  },
  {
    path: 'videos',
    component: () => import('~/admin/pages/videos'),
    name: 'admin-videos',
  },
  {
    path: 'videos/:id',
    component: () => import('~/admin/pages/videos-edit'),
    name: 'admin-video-edit',
  },
  {
    path: 'video-gallery',
    component: () => import('~/admin/pages/video-gallery'),
    name: 'admin-video-gallery',
  },
  {
    path: 'video-gallery/:id',
    component: () => import('~/admin/pages/video-gallery-edit'),
    name: 'admin-video-gallery-edit',
  },
  {
    path: 'main-tags',
    component: () => import('~/admin/pages/directory'),
    name: 'admin-main-tags',
  },
  {
    path: 'news-tags',
    component: () => import('~/admin/pages/directory'),
    name: 'admin-news-tags',
  },
  {
    path: 'ai-tags',
    component: () => import('~/admin/pages/ai-tags'),
    name: 'admin-ai-tags',
  },
  {
    path: 'ai-tags/:id',
    component: () => import('~/admin/pages/ai-tags-edit'),
    name: 'admin-ai-tags-edit',
  },
  {
    path: 'ai-tags/:id/materials',
    component: () => import('~/admin/pages/ai-tags-materials'),
    name: 'admin-ai-tags-materials',
  },
  {
    path: 'companies',
    component: () => import('~/admin/pages/objects'),
    name: 'admin-objects-companies',
  },
  {
    path: 'events-companies',
    component: () => import('~/admin/pages/objects'),
    name: 'admin-events-companies',
  },
  {
    path: 'authors',
    component: () => import('~/admin/pages/objects'),
    name: 'admin-objects-authors',
  },
  {
    path: 'persons',
    component: () => import('~/admin/pages/objects'),
    name: 'admin-objects-persons',
  },
  {
    path: 'projects',
    component: () => import('~/admin/pages/objects'),
    name: 'admin-objects-projects',
  },
  {
    path: 'site-settings',
    component: () => import('~/admin/pages/site-settings'),
    name: 'admin-site-settings',
  },
  {
    path: 'journals',
    component: () => import('~/admin/pages/journals'),
    name: 'admin-journals',
  },
  {
    path: 'journals/:id',
    component: () => import('~/admin/pages/journals-edit'),
    name: 'admin-journals-edit',
  },
  {
    path: 'journal-editions',
    component: () => import('~/admin/pages/journal-editions'),
    name: 'admin-journal-editions',
  },
  {
    path: 'journal-recommended',
    component: () => import('~/admin/pages/journal-recommended'),
    name: 'admin-journal-recommended',
  },
  {
    path: 'journal-advertising',
    component: () => import('~/admin/pages/journal-advertising'),
    name: 'admin-journal-advertising',
  },
  {
    path: 'journal-orders',
    component: () => import('~/admin/pages/journal-orders'),
    name: 'admin-journal-orders',
  },
];
